import "./AttendanceDepartureReport.css";

function AttendanceDepartureReport() {
  return (
    <>
      <div className="attendancedeparturereport">
        
      </div>
    </>
  );
}

export default AttendanceDepartureReport;
